import {
  FormCheckbox,
  FormInput,
  FormSelect,
  FormTextarea,
  Heading,
  Loader,
} from "@/components";
import { FormProvider } from "react-hook-form";
import useAddEditConfig from "./useAddEditConfig";
import {
  ACTIVE,
  DESCRIPTION,
  DOCUMENT_TYPE,
  DOCUMENT_TYPE_ID,
  TRANSACTIONAL_PROCESSOR,
  UPDATED_AT,
  UPDATED_BY,
} from "./consts";
import { Button } from "@/components/ui";
import { documentTypeOptions, transactionalProcessorOptions } from "@/lib/utils";
import { NumberRangesSection } from "@/pages";

const AddEditConfig = () => {
  const {
    form,
    onSubmit,
    isAdd,
    isDetailLoading,
    breadcrumbData,
    isView,
    onBackClick,
    requiredFields,
    onCancel,
    isAddPending,
    isUpdatePending,
    documentTypeId,
    keys,
    numberRanges,
    onAddRange,
    isAddRangePending,
  } = useAddEditConfig();
  const { errors } = form.formState;

  return (
    <div className="p-4 md:p-6">
      <div className="flex flex-col lg:flex-row lg:items-center w-full justify-between">
        <Heading
          title={isView ? "View Property" : breadcrumbData[1].name}
          showBack
          onBackClick={onBackClick}
          breadcrumbData={breadcrumbData}
        />
      </div>

      {!isAdd && isDetailLoading ? (
        <Loader />
      ) : (
        <FormProvider {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)}>
            <div className="bg-white mt-[20px] rounded-lg px-[30px] py-[25px]">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-[30px]">
                {documentTypeId && (
                  <FormInput
                    name={DOCUMENT_TYPE_ID}
                    control={form.control}
                    label="Document Type ID"
                    placeholder="Please enter"
                    error={errors[DOCUMENT_TYPE_ID]?.message}
                    isRequired={requiredFields.includes(DOCUMENT_TYPE_ID)}
                    disabled
                  />
                )}
                <FormSelect
                  key={keys.documentType}
                  name={DOCUMENT_TYPE}
                  control={form.control}
                  label={
                    <span>
                      Document Type(
                      <span className="text-[10px]">2 char only</span>)
                    </span>
                  }
                  placeholder="Please enter"
                  error={errors[DOCUMENT_TYPE]?.message}
                  isRequired={requiredFields.includes(DOCUMENT_TYPE)}
                  disabled={isView}
                  options={documentTypeOptions}
                />
                <FormSelect
                  key={keys.processor}
                  name={TRANSACTIONAL_PROCESSOR}
                  control={form.control}
                  label={
                    <span>
                      Transactional Processor(
                      <span className="text-[10px]">2 char only</span>)
                    </span>
                  }
                  placeholder="Please enter"
                  error={errors[TRANSACTIONAL_PROCESSOR]?.message}
                  isRequired={requiredFields.includes(TRANSACTIONAL_PROCESSOR)}
                  disabled={isView}
                  options={transactionalProcessorOptions}
                />
                {documentTypeId && (
                  <>
                    <FormCheckbox
                      name={ACTIVE}
                      control={form.control}
                      label="Is Active?"
                      error={errors[ACTIVE]?.message}
                      isRequired={requiredFields.includes(ACTIVE)}
                      disabled={isView}
                    />
                    <FormInput
                      name={UPDATED_AT}
                      control={form.control}
                      label="Last Updated On"
                      placeholder="Please enter"
                      error={errors[UPDATED_AT]?.message}
                      isRequired={requiredFields.includes(UPDATED_AT)}
                      disabled
                    />
                    <FormInput
                      name={UPDATED_BY}
                      control={form.control}
                      label="Last Updated By"
                      placeholder="Please enter"
                      error={errors[UPDATED_BY]?.message}
                      isRequired={requiredFields.includes(UPDATED_BY)}
                      disabled
                    />
                  </>
                )}
                <FormTextarea
                  name={DESCRIPTION}
                  control={form.control}
                  label="Description"
                  placeholder="Please enter"
                  error={errors[DESCRIPTION]?.message}
                  isRequired={requiredFields.includes(DESCRIPTION)}
                  disabled={isView}
                />
              </div>
            </div>
            <NumberRangesSection
              ranges={numberRanges}
              onAddRange={onAddRange}
              isAddPending={isAddRangePending}
              allowAdd={!isView}
            />
            <div className="flex flex-row justify-end gap-3 py-3">
              <Button
                variant="outline"
                type="button"
                onClick={onCancel}
                disabled={isAddPending || isUpdatePending}
              >
                Cancel
              </Button>
              {!isView && (
                <Button
                  type="submit"
                  disabled={isAddPending || isUpdatePending}
                >
                  {isAddPending || isUpdatePending ? (
                    <Loader variant="secondary" />
                  ) : (
                    <></>
                  )}{" "}
                  Save
                </Button>
              )}
            </div>
          </form>
        </FormProvider>
      )}
    </div>
  );
};

export default AddEditConfig;
